// import { 
//   GET_ALL_HOSPITAL_AGENTS, GET_HOSPITAL_AGENT_BY_ID, 
//   GET_AGENT_STAFF_COMBINED, GET_HELPDESK_DISTINCT_DEPTS, 
//   CREATE_HOSPITAL_AGENT, UPDATE_HOSPITAL_AGENT, DELETE_HOSPITAL_AGENT 
// } from "../actions/types";

// const initialState = {
//   agents: [],
//   combinedAgents: [],
//   selectedAgent: null,
//   distinctDepts: [],
//   saveStatus: false,
//   updateStatus: false,
//   deleteStatus: false
// };

// export default function helpdeskAgentReducer(state = initialState, action) {
//   switch (action.type) {
//     case GET_ALL_HOSPITAL_AGENTS: return { ...state, agents: action.payload.data };
//     case GET_AGENT_STAFF_COMBINED: return { ...state, combinedAgents: action.payload.data };
//     case GET_HOSPITAL_AGENT_BY_ID: return { ...state, selectedAgent: action.payload.data };
//     case GET_HELPDESK_DISTINCT_DEPTS: return { ...state, distinctDepts: action.payload.data };
//     case CREATE_HOSPITAL_AGENT: return { ...state, saveStatus: action.payload.success };
//     case UPDATE_HOSPITAL_AGENT: return { ...state, updateStatus: action.payload.success };
//     case DELETE_HOSPITAL_AGENT: return { ...state, deleteStatus: action.payload.success };
//     default: return state;
//   }
// }
import {
  GET_ALL_HOSPITAL_AGENTS,
  GET_HOSPITAL_AGENT_BY_ID,
  GET_AGENT_STAFF_COMBINED,
  GET_HELPDESK_DISTINCT_DEPTS,
  CREATE_HOSPITAL_AGENT,
  UPDATE_HOSPITAL_AGENT,
  DELETE_HOSPITAL_AGENT,
} from "../actions/types";

// ✅ Pattern same as setuphrstaffbasicinformationReducer.js

const initialState = {
  agentList: [],
  combinedAgents: [],
  selectedAgent: null,
  distinctDepts: [],
  agentSaveStatus: null,
  agentUpdateStatus: null,
  agentDeleteStatus: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_HOSPITAL_AGENTS:
      return {
        ...state,
        agentList: action.payload.data,
      };

    case GET_AGENT_STAFF_COMBINED:
      return {
        ...state,
        combinedAgents: action.payload.data,
      };

    case GET_HOSPITAL_AGENT_BY_ID:
      return {
        ...state,
        selectedAgent: action.payload.data,
      };

    case GET_HELPDESK_DISTINCT_DEPTS:
      return {
        ...state,
        distinctDepts: action.payload.data,
      };

    case CREATE_HOSPITAL_AGENT:
      return {
        ...state,
        agentSaveStatus: action.payload.success,
      };

    case UPDATE_HOSPITAL_AGENT:
      return {
        ...state,
        agentUpdateStatus: action.payload.success,
      };

    case DELETE_HOSPITAL_AGENT:
      return {
        ...state,
        agentDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}